<div class="custom-snackbar d-flex justify-content-between align-items-center">
    <div>
        <img src="./assets/images/svg/done-icon.svg" alt="" class="mx-3 w-20-px">
        <span class="text-dark">Successfully saved</span>
    </div>
    <button mat-icon-button (click)="dismissSnackbar()" class="close-button">
        <mat-icon class="close-icon">close</mat-icon>
    </button>
</div>
